import React, { useEffect, useState } from 'react'
import { getStaff } from '../../../services/request.service';
import { useSelector } from 'react-redux';
import InputCheckBox from '../InputCheckBox';
import Swal from 'sweetalert2';

const Step2 = ({page, setPage, formData, setFormData}) => {
  const [allStaffs, setAllStafss] = useState([])
  const [staffs, setStaffs] = useState([]);
  const auth = useSelector((state) => state.auth.user.id);


  const showAlert = () => {
    Swal.fire({
      title: "Advertencia",
      text: "Desea agregar el personal?",
      icon: "info",
      showDenyButton: true,
      denyButtonText: "No",
      confirmButtonText:"Si",
      confirmButtonColor: "#3085d6",
    }).then(response => {
      if (staffs.length !== 0 && response.isConfirmed) {
        onSubmit();
        Swal.fire({
          title: "Registro exitoso",
          text: "Personal ingresado con exito",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#3085d6",
        });
      }else{
        Swal.fire({
          title: "Advertencia",
          text: "No se ha agregado personal, por favor ingrese el personal que realizará la visita",
          icon: "info",
          confirmButtonText: "Ok",
          confirmButtonColor: "#3085d6",
        });
      }
    })
  }


  useEffect(() => {
    (async () => {
      const data = await getStaff(auth);
      setAllStafss(data);
    })();
  },[])

  const onSubmit = () =>{
    setFormData({...formData, staffs: staffs})
    setPage(page + 1);
  }

  const data = (staffId, check) =>{
    if(staffs.find((oneStaff)=> oneStaff.id === staffId)){
      setStaffs(staffs.filter((staff) => staff.id !== staffId))
    }else{
      setStaffs([...staffs, {id: staffId}])
    }
  }

  return (
    <div className="container">
      <div className={`row g-3`}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h5 className="Request-form-h4">{"Personal"}</h5>
        </div>
        <div className="vehicle-content-display">
          <ul className="list-group">
            <ul className="list-group-item list-group-item-action d-none d-lg-inline-block border-bottom ul-request">
              <div className="row">
                <div className="col-lg list-request-title">
                  <strong>Nombre</strong>
                </div>
                <div className="col list-request-title">
                  <strong>Identificacion</strong>
                </div>
                <div className="col list-request-title"></div>
              </div>
            </ul>
            {allStaffs?.map((staff, index) => (
              <span key={index}
                className={`list-group-item ul-request ul-request`}
              >
                <div className="row">
                  <div className="col list-request-title">
                    <strong>{staff.name}</strong>
                  </div>
                  <div className="col col-lg">
                    <small className="d-lg-none mt-1">
                      Show
                      <br />
                    </small>
                    {staff.identification}
                  </div>
                  <InputCheckBox setData={data} dataId={staff.id} />
                </div>
              </span>
            ))}
          </ul>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "15px",
            }}
          >
            <button
              className={"btn btn-success btn-sm"}
              onClick={() => {
                setPage(page - 1);
              }}
            > 
              Anterior
            </button>
            <button className={"btn btn-success btn-sm"} onClick={showAlert}>
              Siguente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step2;